module.exports = __webpack_public_path__ + "img/CLS-P-290.e0a87403.svg";